import { httpClient } from 'core/net/http';
import HttpResponse from 'core/net/HttpResponse';
import debounce from 'lodash/fp/debounce';

export const LOG_LEVEL = {
  Fatal: 0,
  Error: 1,
  Warning: 2,
  Info: 3,
  Debug: 4,
} as const;

export type LogLevel = typeof LOG_LEVEL;

const handleLog = async (body: {
  level: LogLevel[keyof LogLevel];
  message: string;
  url: string;
  exception: string;
}) => {
  const response: HttpResponse<unknown> = await httpClient.useInternalApi.asAuthorised().post('log', body);

  if (!response.isSuccess) {
    return console.error(`Failed to log error`, body);
  }
};

/**
 * Debouncing by a second to avoid accidentally bringing down the API
 */
export const logToServer = debounce(1000, handleLog);
